import { initSliders } from 'components/swiper-init/index';

import './index.scss';

const blockSliderBrands = () => {
	initSliders('.block-slider-brands .slider-content .swiper');
};

export default blockSliderBrands;
